import { Box, Typography } from "@mui/material";
import styled from "styled-components";

export const ProcessCardParagraph = styled(Box)`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props?.theme.colors[props?.$color ?? "white"]};
  border-radius: 15.4348px;
  gap: 10px;
`;

export const ProcessCardImage = styled.div`
  background-color: ${(props) => props?.$color ?? "white"};
  border-radius: 6.75px;
  width: 90px;
  height: 90px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ProcessImageCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 90px;

  align-items: center;
  gap: 10px;

  @media (max-width: 1040px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    height: fit-content;
    > :last-child {
      margin-left: 31.5px;
    }
  }
`;

export const ProcessCardHeader = styled(Typography)`
  width: 159px;
  height: 22px;
  font-weight: 700;
  font-size: 20.25px;
  line-height: 22px;
  padding-left: 1px;

  background-color: ${(props) => props?.$color ?? "white"};
  color: ${(props) =>
    props?.$color === props?.theme.colors?.primary
      ? props?.theme.colors?.white
      : props?.theme.colors?.dark};
`;

export const ProcessCardParagraphText = styled(Typography)`
  font-weight: 400;
  //font-style: italic;
  font-size: 13.5px;
  color: ${(props) => props?.theme.colors?.white};
`;

export const ProcessCardBadges = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
export const ProcessCardBadge = styled(Typography)`
  border-radius: 16.5px;
  padding: 4.5px;
  background-color: ${(props) => props?.$color ?? "white"};
  color: ${(props) =>
    props?.$color === props?.theme.colors?.primary
      ? props?.theme.colors?.white
      : props?.theme.colors?.dark};

  font-weight: 400;
  font-size: 11.25px;
  line-height: 100%;
  letter-spacing: 0%;

  &::before {
    content: "•";
    border-top-left-radius: 16.5px;
    border-bottom-right-radius: 16.5px;
    font-size: 1.2em;
    //padding: 2.25px;
    padding-right: 2.25px;
  }
`;

export const ProcessCardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 278px;
  @media (max-width: 1200px) {
    max-width: 240px;
  }
  @media (max-width: 1040px) {
    &:last-of-type {
      padding-bottom: 120px;
    }
  }
  @media (max-width: 600px) {
    &:last-of-type {
      padding-bottom: 32px;
    }
  }
`;
